import { sidebarActionTypes } from '@/admin/components/sideBar/Constants';

import type { SidebarActionTypes, SidebarState } from '@/admin/components/sideBar/types';

const initialState: SidebarState = {
	expanded: true,
	isOpenedSettingsMenu: false,
};

export default function sidebarReducer(
	state = initialState,
	action: SidebarActionTypes,
): SidebarState {
	const { type, payload } = action;
	const { status } = payload || {};

	switch (type) {
		case sidebarActionTypes.SET_EXPANDED_MENU:
			return {
				...state,
				expanded: status,
			};

		case sidebarActionTypes.SET_SETTINGS_MENU:
			return {
				...state,
				isOpenedSettingsMenu: status,
			};

		default:
			return state;
	}
}
